<mat-card style="border-color: #5775a8;">


  <mat-card-content>
    <!-- <complaint-complaintBusinessInfo></complaint-complaintBusinessInfo> -->
    <business-businessInfo [parentPanel]=0></business-businessInfo>
    <br/>
    <business-businessComments [businessId]="businessId" [parentPanel]="0"></business-businessComments>
  </mat-card-content>

</mat-card>